module.exports = __webpack_public_path__ + "ca312cad3cccf069e472d143ee551329.png";